export default __webpack_public_path__ + "f4dfcfb3ca2df5a6b59ae7f834a52ef3.twig";